import React from 'react'
import ImageWrap from 'components/ImageWrap'

export default function PostImage({ content }) {
  const { image } = content
  return (
    <section className='image'>
      {image.desktop && (
        <ImageWrap className='desktop-only' image={image.desktop} />
      )}
      {image.mobile && (
        <ImageWrap className='mobile-only' image={image.mobile} />
      )}
    </section>
  )
}
